import { Input, Select, Button, Form, DatePicker } from "antd";
import { STATUS_TYPE, FORMS, BUTTONS } from "../common/constants";

const CreateVehicleForm = ({ handleSubmit }) => {

  const { Option } = Select;

  const getFormFieldRule = (field, pattern, errorMessage) => [
    {
      required: true,
      message: `Please Enter ${field}!`,
    },
    {
      pattern,
      message: errorMessage,
    },
  ];

  // const ownerList = [{id: 1, value: "Test 1"}, {id: 2, value: "Test 2"}, {id: 3, value: "Test 3"}];
  // const dealerList = [{id: 1, value: "Dealer 1"}, {id: 2, value: "Dealer 2"}, {id: 3, value: "Dealer 3"}, {id: 4, value:"Dealer 4"}]
  const orgList = [{id: 1, name: "Org 1"}, {id: 2, name: "Org 2"}, {id: 3, name: "Org 3"}];
  const MFRList = [{id: 1, name: "NDS"}, {id: 2, name: "LML"}, {id: 3, name: "Simpson"}];
  const modelList = [{id: 1, value: "Model 1"}, {id: 2, value: "Model 2"}, {id: 3, value: "Model 3"}, {id: 4, value:"Model 4"}]
  const colorList = [{id: 1, value: "Green"}, {id: 2, value: "Blue"}, {id: 3, value: "Yellow"}, {id: 4, value:"White"}]

  const statusType = [
    STATUS_TYPE.ACTIVE,
    STATUS_TYPE.INACTIVE,
  ];

  const onChange = (date, dateString) => {
    // console.log(date, dateString);
  };

  return (
    <Form 
      onFinish={handleSubmit} 
      autoComplete="off" 
      className="add-vehicle-form mt2"
      initialValues={{
        owner: "Owner 1",
        dealership: "Dealer 1"
      }}
    >
      
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.IMEI.NAME}
        label={FORMS.VEHICLE.FIELDS.IMEI.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.IMEI.LABEL
        )}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.ORG_ID.NAME}
        label={FORMS.VEHICLE.FIELDS.ORG_ID.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.ORG_ID.LABEL
        )}
      >
        <Select
          allowClear
          placeholder={FORMS.VEHICLE.FIELDS.ORG_ID.PLACEHOLDER}
        >
          {orgList.map((org, index) => (
            <Option key={index} value={org.id}>
              {org.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.MFR_ID.NAME}
        label={FORMS.VEHICLE.FIELDS.MFR_ID.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.MFR_ID.LABEL
        )}
      >
        <Select
          allowClear
          placeholder={FORMS.VEHICLE.FIELDS.MFR_ID.PLACEHOLDER}
        >
          {MFRList.map((data, index) => (
            <Option key={index} value={data.id}>
              {data.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.MFRDATE.NAME}
        label={FORMS.VEHICLE.FIELDS.MFRDATE.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.MFRDATE.LABEL
        )}
      >
        <DatePicker onChange={onChange} className="mfrdate-picker" popupClassName="mfrdate-popover" />
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.MODEL.NAME}
        label={FORMS.VEHICLE.FIELDS.MODEL.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.MODEL.LABEL
        )}
      >
        <Select
          allowClear
          placeholder={FORMS.VEHICLE.FIELDS.MODEL.PLACEHOLDER}
        >
          {modelList.map((type, index) => (
            <Option key={index} value={type.id}>
              {type.value}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.COLOR.NAME}
        label={FORMS.VEHICLE.FIELDS.COLOR.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.COLOR.LABEL
        )}
      >
        <Select
          allowClear
          placeholder={FORMS.VEHICLE.FIELDS.COLOR.PLACEHOLDER}
        >
          {colorList.map((type, index) => (
            <Option key={index} value={type.id}>
              {type.value}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.DEALERSHIP.NAME}
        label={FORMS.VEHICLE.FIELDS.DEALERSHIP.LABEL}
      >
        <input value={"dealer 1"} disabled={true} />
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.OWNER.NAME}
        label={FORMS.VEHICLE.FIELDS.OWNER.LABEL}
      >
        <input value={"owner 1"} disabled />
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.NET_WEIGHT.NAME}
        label={FORMS.VEHICLE.FIELDS.NET_WEIGHT.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.NET_WEIGHT.LABEL
        )}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.CHASSIS.NAME}
        label={FORMS.VEHICLE.FIELDS.CHASSIS.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.CHASSIS.LABEL
        )}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FORMS.VEHICLE.FIELDS.STATUS.NAME}
        label={FORMS.VEHICLE.FIELDS.STATUS.LABEL}
        rules={getFormFieldRule(
          FORMS.VEHICLE.FIELDS.STATUS.LABEL
        )}
      >
        <Select
          placeholder={FORMS.VEHICLE.FIELDS.STATUS.PLACEHOLDER}
        >
          {statusType.map((type, index) => (
            <Option key={index} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Button type="primary" htmlType="submit">
        {BUTTONS.CREATE}
      </Button>
    </Form>
  );
};

export default CreateVehicleForm;
